import { axios, url } from "@/plugin/axios";

export default {
  getOffers() {
    return axios.get(`${url}admin/offers`);
  },
  getConversations(id) {
    return axios.get(`${url}conversations/messages/${id}`);
  },
  updatePointStatus(id) {
    return axios.patch(`${url}point/admin/orders/${id}`);
  }
};
